import React from 'react';
import styled from 'styled-components/macro';

import { EntityType } from '../../../types.generated';
import { EmptyTab } from '../shared/components/styled/EmptyTab';
import { RelationshipItem, GlossaryRelatedEntity } from '../shared/types';
import RelatedNode from '../glossaryTerm/profile/RelatedTerm';

export enum RelatedNodeTypes {
    isTypeOf = 'Has Type',
    typeOfRelations = 'Type Of',
    isRelatedTerms = 'Inherits',
    hasRelatedTerms = 'Contains',
    containedBy = 'Contained by',
    isAChildren = 'Inherited by',
}

export type Props = {
    loading?: boolean;
    glossaryRelatedNodeType: string;
    glossaryRelatedNodeResult: RelationshipItem[];
    canRemoveRelatedTerms?: boolean;
    canRemoveRelatedNodes?: boolean;
    removeDisabledTooltip?: string;
};

const ListContainer = styled.div`
    width: 100%;
`;

export default function GlossaryRelatedNodesResult({
    loading,
    glossaryRelatedNodeType,
    glossaryRelatedNodeResult,
    canRemoveRelatedTerms = true,
    canRemoveRelatedNodes = true,
    removeDisabledTooltip,
}: Props) {
    const glossaryRelatedNodes: GlossaryRelatedEntity[] = glossaryRelatedNodeResult.map((item) => ({
        urn: item.entity?.urn || '',
        type: item.entity?.type || '',
        isInverse: item.isInverse,
        relationshipType: item.relationshipType,
        customRelationTypeUrn: item.customRelationTypeUrn || '',
        previewData: item.entity,
    }));

    const getEntityType = (entityType: string) => {
        if (!entityType) {
            return EntityType.GlossaryNode;
        }
        return entityType === EntityType.GlossaryTerm ? EntityType.GlossaryTerm : EntityType.GlossaryNode;
    };

    const getCanRemove = (entityType: EntityType) =>
        entityType === EntityType.GlossaryTerm ? canRemoveRelatedTerms : canRemoveRelatedNodes;

    return (
        <ListContainer>
            {glossaryRelatedNodes.map((entity) => (
                <RelatedNode
                    urn={entity?.urn}
                    isLoading={loading}
                    isInverse={entity?.isInverse}
                    previewData={entity?.previewData}
                    entityType={getEntityType(entity?.type)}
                    key={`${entity?.urn}-${entity?.relationshipType}`}
                    customRelationTypeUrn={entity?.customRelationTypeUrn || ''}
                    relationshipType={entity?.relationshipType}
                    canRemove={getCanRemove(getEntityType(entity?.type))}
                    removeDisabledTooltip={removeDisabledTooltip}
                />
            ))}
            {glossaryRelatedNodes.length === 0 && <EmptyTab tab={glossaryRelatedNodeType.toLocaleLowerCase()} />}
        </ListContainer>
    );
}
